import React from 'react';

const SingleRoadmapAdminViewSkeleton = () => {
  return (
    <div className="animate-pulse text-white">
      {/* Header Placeholder */}
      <div className="h-16 bg-slate-800 rounded-lg mb-6"></div> {/* Mimics Header component */}

      <div className="bg-slate-900 space-y-6 p-4 rounded-lg border border-slate-700">
        {/* Hero Section Placeholder */}
        <div className="relative rounded-lg bg-slate-800 p-6 h-48">
          <div className="flex start space-x-4">
            <div className="w-12 h-12 bg-slate-700 rounded-full"></div>
            <div className="flex items-start flex-col">
              <div className="h-8 bg-slate-700 rounded w-64 mb-2"></div>
              <div className="h-6 bg-blue-900 rounded-full w-32"></div>
            </div>
          </div>
          <div className="absolute bottom-6 left-6 right-6">
            <div className="flex items-center justify-between mb-4">
              <div className="h-6 bg-slate-700 rounded w-48"></div>
              <div className="h-8 bg-slate-700 rounded w-24"></div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {[...Array(3)].map((_, i) => (
                <div key={i} className="bg-slate-700 rounded-xl p-4 h-32">
                  <div className="h-4 bg-slate-600 rounded w-3/4 mb-2"></div>
                  <div className="h-3 bg-slate-600 rounded w-1/2 mb-4"></div>
                  <div className="h-2 bg-slate-600 rounded-full w-full"></div>
                  <div className="h-3 bg-slate-600 rounded w-full mt-2"></div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Levels and Items Placeholder */}
        <div className="h-fit space-y-6 mt-8">
          {[...Array(3)].map((_, levelIndex) => (
            <div key={levelIndex}>
              <div className="flex justify-between mb-6">
                <div className="flex items-center space-x-4">
                  <div className="w-10 h-10 bg-slate-700 rounded-full"></div>
                  <div>
                    <div className="h-6 bg-slate-700 rounded w-32 mb-1"></div>
                    <div className="h-4 bg-slate-700 rounded w-48"></div>
                  </div>
                </div>
                <div className="text-right">
                  <div className="h-6 bg-slate-700 rounded w-16 mb-1"></div>
                  <div className="h-4 bg-slate-700 rounded w-24"></div>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {[...Array(levelIndex === 0 ? 3 : 2)].map((_, itemIndex) => ( // Simulate different numbers of items
                  <div key={itemIndex} className="p-4 rounded-xl border border-slate-700 bg-slate-800 h-48">
                    <div className="h-5 bg-slate-700 rounded w-24 mb-3"></div>
                    <div className="h-6 bg-slate-700 rounded w-3/4 mb-2"></div>
                    <div className="h-4 bg-slate-700 rounded w-full mb-3"></div>
                    <div className="h-4 bg-slate-700 rounded w-2/3 mb-4"></div>
                    <div className="flex items-center space-x-4">
                      <div className="h-4 bg-slate-700 rounded w-20"></div>
                      <div className="h-4 bg-slate-700 rounded w-24"></div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SingleRoadmapAdminViewSkeleton;
